import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/imports_/$importId')({
  staticData: { title: 'Import' },
})
